import { render, staticRenderFns } from "./CreateSession.vue?vue&type=template&id=47480a16&scoped=true"
import script from "./CreateSession.vue?vue&type=script&lang=js"
export * from "./CreateSession.vue?vue&type=script&lang=js"
import style0 from "./CreateSession.vue?vue&type=style&index=0&id=47480a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47480a16",
  null
  
)

export default component.exports